import React, { useState } from 'react';

import { Button } from '@host/components/NewUI/ComponentsLibrary';

import FileDropzone from './components/FileDropzone';
import Layout from './components/Layout';
import PortalBackButton from './components/PortalBackButton';
import PortalCard from './components/PortalCard';
import PortalFooter from './components/PortalFooter';
import { palette } from './styles';
import { onboardColors } from '../theme/onboardTokens';

import type { IPortalItemRow } from './types';

interface Props {
  item: IPortalItemRow;
  onBack: () => void;
  // The candidate's own upload, shown once the item is submitted.
  submittedDocument?: React.ReactNode;
  onSubmit: (files: File[]) => Promise<void>;
}

const AttachDocument: React.FC<Props> = ({ item, onBack, onSubmit, submittedDocument }) => {
  const [files, setFiles] = useState<File[]>([]);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async () => {
    if (files.length === 0) return;
    setSubmitting(true);
    setError(null);
    try {
      await onSubmit(files);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Upload failed');
      setSubmitting(false);
    }
  };

  return (
    <Layout title={item.label}>
      <PortalCard>
        <div style={{ marginBottom: 24 }}>
          <PortalBackButton onClick={onBack} />
        </div>

        {submittedDocument ? (
          <div style={{ marginTop: -24, marginBottom: 24 }}>{submittedDocument}</div>
        ) : null}

        <p style={{ fontSize: 16, color: palette.black, margin: '0 0 24px' }}>
          {item.label}
          {item.required ? <span style={{ color: onboardColors.status.warningRed }}>*</span> : null}
        </p>

        <FileDropzone
          files={files}
          onFiles={(picked) => setFiles((curr) => [...curr, ...picked])}
          onRemove={(index) => setFiles((curr) => curr.filter((_, i) => i !== index))}
        />

        {error ? (
          <p style={{ color: palette.warning, fontSize: 14, marginTop: 16 }}>{error}</p>
        ) : null}
      </PortalCard>

      <PortalFooter>
        <Button
          buttonVariant="primary"
          disabled={submitting || files.length === 0}
          id="portal-submit-document-button"
          onClick={handleSubmit}
        >
          {submitting ? 'Submitting…' : 'Submit'}
        </Button>
      </PortalFooter>
    </Layout>
  );
};

export default AttachDocument;
